export default {
	WAIT: 0,
	START_ACTIVITY: 1,
}
